import { memo } from 'react';

import ClaimModal from './ClaimModal';
import { PayRateType } from '@scale/shared/defaults';

type TaskHoursExceededModalProps = {
  nextTaskOnExpirationHandler?: () => void;
  payRateType?: PayRateType;
};

const taskExpiredText = (payRateType?: PayRateType) => {
  if (payRateType === PayRateType.HourlyTraining) {
    return (
      <>
        <p>The due date for this task has expired.</p>
        <p className="text-danger-500">
          <br></br>
          <em>
            {' '}
            Note: Since this is an assessment task, you will receive another chance at completing
            this task.
          </em>
        </p>
      </>
    );
  } else {
    return (
      <>
        <p>The due date for this project has expired.</p>
        <p className="text-danger-500">
          <br></br>
          <em> Note: We expire tasks in accordance with our clients' submission timelines.</em>
        </p>
      </>
    );
  }
};
function TaskHoursExceededModal(props: TaskHoursExceededModalProps) {
  return (
    <ClaimModal
      confirmButtonText="Go to next task"
      onConfirmButtonClick={() => props?.nextTaskOnExpirationHandler?.()}
      title="Task expired"
      subtitle={taskExpiredText(props.payRateType)}
    />
  );
}

export default memo(TaskHoursExceededModal);
